module.exports = __webpack_public_path__ + "static/img/bg-lx2.66885a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-lx2.png
// module id = xHYm
// module chunks = 0